var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fieldsResolved),function(field){return _c('field',{key:field.attribute,attrs:{"field":field,"form":_vm.formResolved,"model":_vm.modelResolved,"layout":_vm.layout,"first":_vm.first},on:{"input":_vm.input}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }